import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { updateEstablishmentSettings } from "../../actions/establishments/establishmentSettings";
import ActionMenu from "../sub/ActionMenu";

class EstablishmentShippingCostRow extends React.Component {
  updateShippingCosts(shippingCosts) {
    const data = {
      establishmentId: this.props.establishmentId,
      updatedField: "shipping_costs",
      updatedValue: shippingCosts,
    };

    // Send to BE
    this.props.onUpdateEstablishmentSettings(data);
  }

  openShippingModal(index, successCallbackUpdate) {
    this.props.openShippingModal(index, successCallbackUpdate);
  }

  openConfModal(modalTitle, modalContent, successCallbackDelete) {
    this.props.openConfModal(modalTitle, modalContent, successCallbackDelete);
  }

  splice(array, index) {
    const newArray = [...array];
    newArray.splice(index, 1);
    return newArray;
  }

  render() {
    // 'Delete shipping setting' modal setup
    var modalTitle = <FormattedMessage id="Confirm" />;
    var modalContent = <FormattedMessage id="Remove.Row.Confirmation" />;
    var successCallbackDelete = () =>
      this.updateShippingCosts(
        this.splice(this.props.shippingCosts, this.props.index),
      );

    // Shipping modal set up
    var successCallbackUpdate = (shippingCosts) =>
      this.updateShippingCosts(shippingCosts);

    var max = !this.props.shippingCost.max ? (
      <FormattedMessage id="Infinity" />
    ) : (
      <span>{this.props.shippingCost.max}</span>
    );

    let menuItems = [];

    menuItems.push(
      // edit
      {
        icon: "pen-to-square",
        action: () =>
          this.openShippingModal(this.props.index, successCallbackUpdate),
        text: <FormattedMessage id="Modify" />,
        disabled: false,
      },
      // Delete
      {
        icon: "trash",
        action: () =>
          this.openConfModal(modalTitle, modalContent, successCallbackDelete),
        text: <FormattedMessage id="Delete" />,
        disabled: false,
      },
    );

    let menuAction = <ActionMenu items={menuItems} disabled={false} />;

    return (
      <tr key={this.props.key} className="tre4coll">
        <td>
          <span className="d-sm-none">
            {this.props.shippingCost.min} / {max}
          </span>
          <span className="d-none d-sm-table-cell">
            {this.props.shippingCost.min}
          </span>
        </td>
        <td className="d-none d-sm-table-cell">{max}</td>
        <td>{this.props.shippingCost.cost}</td>
        <td className="text-center">{menuAction}</td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.user.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateEstablishmentSettings: (data) =>
      dispatch(updateEstablishmentSettings(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EstablishmentShippingCostRow);
